<template>
  <div class="interiorzone">
    <h2 class="subheading">贴现数据更新</h2>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-list">
          <li class="hd">
            <span>序号</span>
            <span>公司名称</span>
            <span>社会信用代码</span>
            <span>注册手机号</span>
            <span>上一工作日查询次数</span>
            <span>拟分配贴现行</span>
            <span>操作</span>
            <span>更新结果</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.companyName}}</span>
            <span>{{item.organizationCode}}</span>
            <span>{{item.mobile}}</span>
            <span>{{item.num}}</span>
            <span>网商银行</span>
            <span class="infoperation"><i @click="openpanel(1,item)">点此解析贴现记录</i><i @click="openpanel(2,item)" v-if="item.addStatus==1">点此更新贴现记录</i></span>
            <span class="infoperation"><div class="ysbox"><i @click="allupdate(item.uid,item.organizationCode)">已更新</i></div></span>
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>

    <div class="rejectbox tpadd" v-if="islistmap" :class="this.isticket?'bull':''">
      <h2 class="h2">本次新增{{recordnum}}条数据</h2>
      <ul>
        <li>
          <span>序号</span>
          <span>票据号</span>
          <span>操作</span>
        </li>
        <li v-for="(pt,index) in Piaolist" :key="index">
          <span>{{index+1}}</span>
          <span :title="pt.billCode" :alt="pt.billCode">{{pt.billCode}}</span>
          <span  class="infoperation"><i @click="ticketbox(pt.billCode)">输入待解析数据</i>
          <i>上传贴现凭证
              <input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event,pt.billCode)"   accept="image/png,image/jpeg,image/jpg"/>
          </i>
          <i class="iconfont icon-31xuanze alert" :class="upimglist.indexOf(pt.billCode)!='-1'?'':'bull'" :title="upimglist.indexOf(pt.billCode)!='-1'?'已上传':''" :alt="upimglist.indexOf(pt.billCode)!='-1'?'已上传':''"></i>
          <i @click="update(pt.billCode)">更新</i></span>
        </li>
      </ul>
      <div class="btn-confirm"><button class="addok"  @click="datanalysis()">已全部更新</button> <button class="addno" @click="colosepanel(1)">取消</button></div>
    </div>

    <div class="rejectbox" v-if="isticket">
      <h1>请粘贴需要解析的单次贴现详情：</h1>
      <h2 class="h2">票号：{{ticketnumber}}</h2>
      <textarea v-model="compilebox"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="strange()">提交解析</button> <button class="addno" @click="colosepanel(1)">取消</button></div>
    </div>

    <div class="rejectbox" v-if="isanalysis">
      <h1>请粘贴需要解析的企业贴现记录：</h1>
      <h2 class="h2">{{recordname}}</h2>
      <textarea v-model="analysisdata"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="datanalysis()">提交解析</button> <button class="addno" @click="colosepanel(1)">取消</button></div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      companyName:'',
      companylist:[],
      ifpageshow:false,
      recordname:'xxxx有限公司',
      isanalysis:false,
      analysisdata:'',
      arc:'',
      recordnum:'',
      islistmap:false,
      nowid:'',
      Piaolist:[],
      ticketnumber:'',
      isticket:false,
      compilebox:'',
      listarray:[],
      imga:'',
      upimglist:[]
    }
  },
  mounted:function() {
    this.readlist()
  },
  methods: {
    readlist(){
     this.ajax.post('/auth/selectUpdateList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data.listResponse
          }
        }
      )
    },
    openpanel(val,data){
      this.recordname=data.name
      this.arc=data.organizationCode
      this.nowid=data.uid
      console.log()
      if(val==1){
        this.isanalysis=true
      }
      else if(val==2){
        this.lookadd()
      }
    },
    upimg(val){
      return this.ajax.post('/upload/piaoPingZheng?billCode='+this.imga, val)
        .then(resolve => {
          if(resolve.data.status=="0000"){
            return Promise.resolve(resolve.data.data) ;
          }
          else{
            swal({
              text: resolve.data.message,
              timer: 2000,
              buttons: false
            })
            return Promise.resolve("")
          }
        }
      )
    },
    addImga(e,val){
      let file = e.target.files[0]
      let mbyte=Number(file.size)/1024/1024
      if(mbyte>2){
        swal({
          text: '图片过大，请使用小于2MB的文件！~',
          timer: 2000,
          buttons: false
        })
      }
      else{
        this.imga=val
        let param = new FormData()
        param.append('file', file, file.name)
        this.upimg(param).then(resolve=>{
          if(resolve!=""){
            let picurl=this.versatile.imgUrl+resolve
            this.upimglist.push(this.imga)
            this.imga=""
            swal({
              text: '上传成功！~',
              icon: "success",
              timer: 2000,
              buttons: false
            })
          }
        })
      }
    },
    strange(){
      let abv = JSON.parse(this.compilebox)
      let abc=abv.data.serviceRep.viewHtml
      this.listarray=new Array()
      abc=abc.replace(abc ? /&(?!#?\w+;)/g : /&/g, '&amp;').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#39;/g, "\'").replace(/\\n/g,'').replace(/\\t/g,'')
      abc=abc.substring(abc.indexOf('<body>')+6,abc.indexOf('</body>'))
      abc=abc.replace(/<[^>]+>/g,",")
      abc=abc.replace(/\s+/g,"")
      let acp=abc.split(',')
      for(let i=0;i<acp.length;i++){
        if(acp[i]!=""){
          this.listarray.push(acp[i])
        }
      }
      this.ajax.post('/auth/updatePiaoDetail',{bizContent: {billCode:this.ticketnumber,listarray:this.listarray}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '解析成功！~',
              timer: 2000,
              icon: "success",
              buttons: false
            })
            this.isticket=false
          }
        }
      )
    },
    ticketbox(val){
      this.ticketnumber=val
      this.isticket=true
    },
    lookadd(){
      this.ajax.post('/auth/addPiaolist',{bizContent:{uid:this.nowid,organizationCode:this.arc}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.recordnum=result.data.data.length
            this.Piaolist=result.data.data
            this.islistmap=true
          }
        }
      )
    },
    nextpage(item){
      this.currentPage=item
      this. readlist()
    },
    datanalysis(){
      console.log(this.analysisdata)
      let ac=JSON.parse(this.analysisdata)
      this.ajax.post('/auth/analysisSource',{bizContent: {uId:this.nowid,strParam:this.analysisdata,organizationCode:this.arc}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.isanalysis=false
            this.readlist()
            this.analysisdata=''
          }
        }
      )
    },
    colosepanel(val){
      if(val==1){
        this.isanalysis=false
      }
    },
    update(val){
      this.ajax.post('/auth/piaoDetailHadUpdate',{bizContent: {billCode:val,uid:this.nowid,organizationCode:this.arc}})
      .then(
        result=>{
          this.readlist()
          this.islistmap=false
        }
      )
    },
    allupdate(key,val){
      this.ajax.post('/auth/dealUpdateOrder',{bizContent: {uId:key,organizationCode:val}})
      .then(
        result=>{
          this.readlist()

          //this.islistmap=false
        }
      )
    }
  }
}
</script>

<style scoped>
.content-order-listbox{
min-height: 500px;
}
.infoperation i:last-child{
margin-left: 15px;
}
.rejectbox{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  height:334px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
}
.rejectbox h2,.rejectbox textarea{
  width:581px;
  margin:0 auto;
  display: block;
  margin-top:10px;
}
.rejectbox h1{
  font-size: 18px;
  text-align: center;
  margin-top:16px;
}
.rejectbox .h2{
  font-size: 14px;
  color:#222222;
}
.rejectbox .hd2{
  font-size: 16px;
  color:#222222;
  margin-top:32px;
}
.rejectbox textarea{
  margin-top:20px;
   width:561px;
  padding:5px 10px;
  height:130px;
  border:1px solid rgba(227,228,229,1);
  margin-bottom: 10px;
}
.rejectbox .btn-confirm button{
  width:240px;
  height:52px;
  line-height:52px;
  border-radius: 2px;
  cursor: pointer;
}
.rejectbox .addno{
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  margin-left:20px;
}
.rejectbox ul{
  width:92%;
  height:auto;
  display: table;
  background:rgba(255,255,255,1);
  border:1px solid rgba(227,228,229,1);
  margin:10px auto;
  overflow: hidden;
}
.rejectbox ul li{
  width:100%;
  height:40px;
  line-height:40px;
  clear: both;
}
.rejectbox ul li span{
  width:45%;
  display: block;
  float: left;
  height:40px;
  line-height:40px;
  text-align: center;
  font-size: 12px;
}
.rejectbox ul li span i{
  max-width: 170px;
  max-height: 20px;
  overflow: hidden;
  position: relative;
}
.rejectbox ul li span i:nth-child(2){
  margin:0 10px;
}
.rejectbox ul li span:nth-child(2){
  width:45%;
}
.rejectbox ul li span:first-child{
  width:10%;
}
.rejectbox ul li:nth-child(odd){
  background-color: #f3f3f3;
  
}
.rejectbox ul li:first-child span{
  font-size: 14px;
}
.tpadd{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  min-height:334px;
  display: table;
  padding-top:10px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
  padding-bottom: 30px;
}
.redio:hover{
  text-decoration: underline;
  color:rgba(61,143,226,1);
}

.content-organ-list li span{width:10%;}
.content-organ-list li span:nth-child(2){width:16.6%;}
.content-organ-list li span:nth-child(5){width:14.6%;}
.content-organ-list li span:nth-child(7){width:18.6%;}
.bull{opacity: 0;}
.uplicense {
  width:224px;
  height:104px;
  position:absolute;
  top:0;
  left:0;
  line-height:99999;
  opacity: 0;
  cursor: pointer;
}
.alert{
  color: rgb(15, 208, 107);
  font-size: 12px;
  text-decoration: none;
}
.alert:hover{
  color: rgb(15, 208, 107);
  font-size: 12px;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/discountdata.vue